<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="insert_edit_pop" width="800">
    <div class="insert_edit_template">
      <div class="input_style insert_edit_left">
        <div class="font_style_set">员工类型:</div>
        <div class="insert_edit_input" style="width: 39%">
          <RadioGroup v-model="employeeType" title="员工类型" type="button">
            <Radio :disabled="addOrEdit" label="0" key="0">座席</Radio>
            <Radio :disabled="addOrEdit" label="1" key="1">普通员工</Radio>
          </RadioGroup>
        </div>
        <div style="height: 100%;display: flex;align-items: center;padding-left: 3px;">
          <el-tooltip slot="label" effect="light" placement="right">
            <div slot="content">
              普通员工较与座席区别：<br/>
              1.添加普通员工不受企业最大座席数限制<br/>
              2.员工设置上普通员工不支持如下设置：员工分机，分机密码，在线客服，视频座席，AI助手，热线号码，归属地<br/>
              3.个人设置上普通员工不支持如下设置：话机设置，外置话机页面接听，挂断后状态设置，自动签入设置，热线号码<br/>
              4.普通员工不支持以下功能：签入，内呼，呼出，挂断，满意度，保持，解除保持，转接，询问，多方，在线客服，员工状态更改，页面点击呼叫<br/>
              5.普通员工不支持查看如下页面：我的工作台模块页面，监控管理模块页面<br/>
            </div>
            <img class="imgTip" :src="questionMark"/>
          </el-tooltip>
        </div>
      </div>
      <div class="input_style insert_edit_left">
        <div class="font_style_set">管理员:</div>
        <div class="insert_edit_input">
          <RadioGroup v-model="employeeManager" title="管理员" type="button">
            <Radio v-for="(option, index) in isOrList" :disabled="agentId=='1'" :label="option.id" :key="index">{{option.name}}</Radio>
          </RadioGroup>
        </div>
      </div>
    </div>
    <div class="insert_edit_template">
      <div class="input_style insert_edit_left">
        <div class="font_style_set"><span class="span_must">*</span>员工编号:</div>
        <div class="insert_edit_input">
          <Input v-model="employeeCode" placeholder="请输入员工编号" title="员工编号"/>
        </div>
      </div>
      <div class="input_style insert_edit_left">
        <div class="font_style_set"><span class="span_must">*</span>员工密码:</div>
        <div class="insert_edit_input">
          <Input v-model="employeePassword" placeholder="请输入员工密码"  title="员工密码"/>
        </div>
      </div>
    </div>
    <div class="insert_edit_template">
      <div class="input_style insert_edit_right">
        <div class="font_style_set"><span class="span_must">*</span>员工姓名:</div>
        <div class="insert_edit_input">
          <Input v-model="employeeName" placeholder="请输入员工姓名" title="员工姓名"/>
        </div>
      </div>
      <div class="input_style insert_edit_left">
        <div class="font_style_set"><span class="span_must">*</span>所属部门:</div>
        <div class="insert_edit_input">
          <el-cascader v-model="employeeDepartment" :options="employeeDepartmentList" placeholder="请选择所属部门" style="width: 100%" size="small" :props="{ checkStrictly: true }" filterable></el-cascader>
        </div>
      </div>
    </div>
    <div class="insert_edit_template">
      <div class="input_style insert_edit_left">
        <div class="font_style_set"><span class="span_must">*</span>员工工号:</div>
        <div class="insert_edit_input">
          <Input v-model="agentNumber" placeholder="请输入员工工号" title="员工工号"  :disabled="editOrAdd" @on-blur="setEmployeeCode"/>
        </div>
      </div>
      <div class="input_style insert_edit_right">
        <div class="font_style_set"><span class="span_must">*</span>员工角色:</div>
        <div class="insert_edit_input">
          <Select v-model="employeeRole" placeholder="请选择员工角色" title="员工角色">
            <Option v-for="(option, index) in employeeRoleList" :value="option.id" :key="index">{{option.roleName}}</Option>
          </Select>
        </div>
      </div>
    </div>
    <div class="insert_edit_template" v-show="'0' == employeeType">
      <div class="input_style insert_edit_left">
        <div class="font_style_set"><span v-show="agentId == ''" class="span_must">*</span>员工分机:</div>
        <div class="insert_edit_input">
          <Select v-model="agentExten" :style="(agentExten=='' || agentExten == undefined)?'color:#c5c8ce':'color:#606266'" placeholder="请选择员工分机" title="默认企业编号+员工编号" @on-change="modifyExten">
            <Option v-show="agentId != ''" value="" key="-1">请选择分机号</Option>
            <Option v-for="(option, index) in extenList" :value="option.agentExten" :key="index">{{option.agentExten}}</Option>
          </Select>
        </div>
      </div>
      <div class="input_style insert_edit_right">
        <div class="font_style_set"><span v-show="agentId == ''" class="span_must">*</span>分机密码:</div>
        <div class="insert_edit_input">
          <Input v-model="extenPassword" placeholder="请输入分机密码" :disabled="disabled" title="分机密码"/>
        </div>
      </div>
    </div>
    <div class="insert_edit_template">
      <div class="input_style insert_edit_right">
        <div class="font_style_set">员工手机:</div>
        <div class="insert_edit_input">
          <Input v-model="employeeMobile" placeholder="请输入员工手机" title="员工手机"/>
        </div>
      </div>
      <div class="input_style insert_edit_left">
        <div class="font_style_set">员工年龄:</div>
        <div class="insert_edit_input">
          <Input v-model="employeeAge" placeholder="请输入员工年龄" title="员工年龄" @on-blur="checkPhoneNumber"/>
        </div>
      </div>
    </div>
    <div class="insert_edit_template">
      <div class="input_style insert_edit_right">
        <div class="font_style_set">员工生日:</div>
        <div class="insert_edit_input">
          <DatePicker type="datetime" v-model="employeeBirthday" format="yyyy-MM-dd" placement="bottom-start" :editable="false"></DatePicker>
        </div>
      </div>
      <div class="input_style insert_edit_right">
        <div class="font_style_set">员工微信:</div>
        <div class="insert_edit_input">
          <Input v-model="employeeWx" placeholder="请输入员工微信" title="员工微信"/>
        </div>
      </div>
    </div>
    <div class="insert_edit_template">
      <div class="input_style insert_edit_left">
        <div class="font_style_set">员工邮箱:</div>
        <div class="insert_edit_input">
          <Input v-model="employeeEmail" placeholder="请输入员工邮箱" title="员工邮箱"/>
        </div>
      </div>
      <div class="input_style insert_edit_left">
        <div class="font_style_set">隐藏号码:</div>
        <div class="insert_edit_input">
          <RadioGroup v-model="hiddenPhone" title="是否隐藏号码" type="button">
            <Radio v-for="(option, index) in isOrList"  :disabled="agentId=='1'"  :label="option.id" :key="index">{{option.name}}</Radio>
          </RadioGroup>
        </div>
      </div>
    </div>
    <div class="insert_edit_template">
      <div class="input_style insert_edit_right">
        <div class="font_style_set">员工性别:</div>
        <div class="insert_edit_input">
          <RadioGroup v-model="employeeSex" title="员工性别" type="button">
            <Radio v-for="(option, index) in employeeSexList" :label="option.id" :key="index">{{option.name}}</Radio>
          </RadioGroup>
        </div>
      </div>
      <div class="input_style insert_edit_left">
        <div class="font_style_set">查看全部客户:</div>
        <div class="insert_edit_input">
          <RadioGroup v-model="viewAllCustomer" title="是否查看全部客户" type="button">
            <Radio v-for="(option, index) in isOrList" :disabled="agentId=='1'" :label="option.id" :key="index">{{option.name}}</Radio>
          </RadioGroup>
        </div>
      </div>
    </div>

    <div class="insert_edit_template" v-show="'0' == employeeType && ('1' == supportAiAssistant || '1' == sysSupportVideo || '1' == sysSupportChat)">
      <div v-if="'1' == sysSupportChat" class="input_style insert_edit_left">
        <div class="font_style_set">在线客服:</div>
        <div class="insert_edit_input" style="width: 54%">
          <RadioGroup v-model="supportChat" title="是否是在线客服" type="button">
            <Radio v-for="(option, index) in isOnlineChat" :label="option.id" :key="index">{{option.name}}</Radio>
          </RadioGroup>
        </div>
        <div style="height: 100%;display: flex;align-items: center;padding-left: 3px;">
          <el-tooltip slot="label" effect="light" placement="right">
            <div slot="content">
              不支持：座席正常使用呼叫通话功能，无法使用在线客服功能<br/>
              支持：座席同时正常使用呼叫通话及在线客服功能<br/>
              仅支持：座席无法使用呼叫通话功能，正常使用在线客服功能
            </div>
            <img class="imgTip" :src="questionMark"/>
          </el-tooltip>
        </div>
      </div>
      <div v-if="'1' == sysSupportVideo" class="input_style insert_edit_left">
        <div class="font_style_set">视频座席:</div>
        <div class="insert_edit_input">
          <RadioGroup v-model="supportVideo" title="是否视频座席" type="button">
            <Radio v-for="(option, index) in isOrList" :label="option.id" :key="index">{{option.name}}</Radio>
          </RadioGroup>
        </div>
      </div>
      <div v-if="'1' == supportAiAssistant  && ('0' == sysSupportVideo || '0' == sysSupportChat)" class="input_style insert_edit_left">
        <div class="font_style_set">AI助手:</div>
        <div class="insert_edit_input">
          <RadioGroup v-model="aiAssistant" title="是否AI助手座席" type="button">
            <Radio v-for="(option, index) in isOrList" :label="option.id" :key="index">{{option.name}}</Radio>
          </RadioGroup>
        </div>
      </div>
    </div>

    <div v-if="('1' == sysSupportVideo && '1' == supportAiAssistant && '1' == sysSupportChat) && '0' == employeeType" class="insert_edit_template">
      <div class="input_style insert_edit_left">
        <div class="font_style_set">AI助手:</div>
        <div class="insert_edit_input">
          <RadioGroup v-model="aiAssistant" title="是否AI助手座席" type="button">
            <Radio v-for="(option, index) in isOrList" :label="option.id" :key="index">{{option.name}}</Radio>
          </RadioGroup>
        </div>
      </div>
    </div>
    <div class="transfer_template">
      <div class="font_style_set">员工地址:</div>
      <div class="transfer_input">
        <Input v-model="employeeArea" placeholder="请输入员工地址" title="员工地址"/>
      </div>
    </div>
    <div class="transfer_template" v-show="'0' == employeeType">
      <div class="font_style_set">热线号码:</div>
      <div class="transfer_input">
        <Select v-model="pstnNumber" multiple :max-tag-count="5" clearable placeholder="请选择热线号码可多选" title="热线号码可多选">
          <Option v-for="(item,index) in pstnNumberList" :value="item.pstnNumber" :key="index">{{ item.pstnNumber}}</Option>
        </Select>
      </div>
    </div>
    <div class="btn_template" style="margin-top:15px">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" :disabled="saveDisabled" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
        name: "AgentEditPop",
        mixins:[publicFunClass],
        props: {
          showAgent:Boolean,
          agentId:String,
          showTitle:String,
          employeeList:Array,
          departmentList:Array,
          agentExtenList:Array
        },
        data(){
          return {
            questionMark:require('../../assets/image/homeAsk.png'),
            model:false,
            disabled:true,
            saveDisabled:false,
            title:'添加员工',
            companyId:localStorage.getItem("companyId"),
            employeeCode:'',
            employeeName:'',
            employeePassword:'******',
            employeeRole:'',
            employeeRoleList:[],
            employeeDepartment:[],
            employeeDepartmentList:[],
            employeeMobile:'',
            agentNumber:'',
            agentExten:'',
            extenPassword:'',
            extenList:[],
            employeeSex:'1',
            employeeSexList:[{'id':'0','name':'男'},{'id':'1','name':'女'}],
            employeeArea:'',
            employeeManager:'',
            employeeAge:'',
            employeeBirthday:'',
            employeeEmail:'',
            employeeWx:'',
            hiddenPhone:'0',
            isOrList:[{'id':'0','name':'否'},{'id':'1','name':'是'}],
            isOnlineChat:[{'id':'0','name':'不支持'},{'id':'1','name':'支持'},{'id':'2','name':'仅支持'}],
            pstnNumber:[],
            pstnNumberList:[],
            id:'',
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            editOrAdd:false,
            aiAssistant:'0',
            supportVideo:'0',
            sysSupportVideo:JSON.parse(localStorage.getItem("sysSupportVideo")),
            supportAiAssistant:JSON.parse(localStorage.getItem("supportAiAssistant")),
            sysSupportChat:JSON.parse(localStorage.getItem("sysSupportChat")),
            supportChat:"0",
            viewAllCustomer:"0",
            employeeType:'0',
            addOrEdit:false,
          }
        },
        methods:{
          setEmployeeCode:function(){
             this.agentExten=this.companyId+this.agentNumber;
             let param={
               agentPassword:this.extenPassword,
               agentExten:this.companyId+this.agentNumber
             };
            this.extenList.push(param);
          },
          modifyExten:function(event){
            let agentInfo=JSON.parse(localStorage.getItem("agentInfo"));
            if(agentInfo.isAdmin!='1'){
              this.disabled=true;
            }
            for(let i=0; i<this.extenList.length; i++){
              let agentExten=this.extenList[i].agentExten;
              if(agentExten==event){
                this.extenPassword=this.extenList[i].agentPassword;
              }
            }
            if(event == undefined){
              this.extenPassword='';
            }
          },
          cancel:function(){
            this.$emit("closeAgentEditPop",false);
          },
          save:function () {
            if(!this.employeePassword){
              this.employeePassword="******";
            }
            if(this.employeeMobile){
              let reg=/^1[3456789]\d{9}$/;
              if(!reg.test(this.employeeMobile)){
                this.$Modal.info({
                  title:'提示',
                  content:"手机号码格式错误"
                });
                return false;
              }
            }
            if(!this.employeeCode){
              this.$Modal.info({
                title:'提示',
                content:"请输入员工编号"
              });
              return false;
            }
            if(!this.employeeName){
              this.$Modal.info({
                title:'提示',
                content:"请输入员工姓名"
              });
              return false;
            }
            if(!this.employeeRole){
              this.$Modal.info({
                title:'提示',
                content:"请选择员工角色"
              });
              return false;
            }
            if(!this.employeeDepartment){
              this.$Modal.info({
                title:'提示',
                content:"请选择员工部门"
              });
              return false;
            }
            if(!this.agentNumber){
              this.$Modal.info({
                title:'提示',
                content:"请输入员工工号"
              });
              return false;
            }
            if(this.agentId == '' && !this.agentExten && '0' == this.employeeType){
              this.$Modal.info({
                title:'提示',
                content:"请选择员工分机"
              });
              return false;
            }
            if(this.agentId == ''){
              if(!this.extenPassword && '0' == this.employeeType){
                this.$Modal.info({
                  title:'提示',
                  content:"分机密码不能为空"
                });
                return false;
              }
            }else{
              if(this.agentExten && this.agentExten.indexOf('请选择分机') == -1 && !this.extenPassword && '0' == this.employeeType){
                this.$Modal.info({
                  title:'提示',
                  content:"分机密码不能为空"
                });
                return false;
              }
            }
            
            let newAgentExten = "";
            let newAgentPassWord = "";
            if("0" == this.employeeType){
              newAgentExten = this.agentExten;
              newAgentPassWord = this.extenPassword;
            }else{
              this.supportVideo = "0";
              this.aiAssistant = "0";
              this.supportChat = "0";
              this.pstnNumber = [];
            }
            if(this.extenPassword){
              let reg=/^([0-9]+[a-zA-Z]+|[a-zA-Z]+[0-9]+)[0-9a-zA-Z]*/;
              if(!reg.test(this.extenPassword)){
                this.$Modal.info({
                  title:'提示',
                  content:"分机密码只能由数字与字母组成"
                });
                return false;
              }
            }
            if(this.agentId == '' && this.extenPassword && '0' == this.employeeType){
              if(this.agentId == '' && this.extenPassword.length<8){
                this.$Modal.info({
                  title:'提示',
                  content:"分机密码不能小于8位"
                });
                return false;
              }
            }
            if(this.employeeEmail){
              let reg=/^[A-Za-z0-9.\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
              if(!reg.test(this.employeeEmail)){
                this.$Modal.info({
                  title:'提示',
                  content:"请输入有效的邮箱"
                });
                return false;
              }
              if(this.employeeEmail.length>40){
                this.$Modal.info({
                  title:'提示',
                  content:"邮箱不能超过40位"
                });
                return false;
              }
            }
            if(this.employeeWx){
              let reg= /^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/;
              if(!reg.test(this.employeeWx)){
                this.$Modal.info({
                  title:'提示',
                  content:"请输入正确的微信号码"
                });
                return false;
              }
            }

            if(!this.agentExten && this.extenPassword){
              this.$Modal.info({
                  title:'提示',
                  content:"未选择员工分机，不保存分机密码"
              });
              return false;
            } 

            let that=this;
            let journalType="用户管理=>员工管理=>添加";
            let menuId="0_2-1";
            let url="employee/insertEmp.json";
            if (this.id){
              url="employee/updateEmp.json";
              journalType="用户管理=>员工管理=>编辑";
              menuId="9_2-6";
            }
            let employeeBirthday = this.employeeBirthday;
            if(this.employeeBirthday){
              employeeBirthday = this.timeChange(employeeBirthday);
            }
            let param={
              employeeCode:this.employeeCode,
              employeeName:this.employeeName,
              employeePassword:this.employeePassword,
              employeeRole:this.employeeRole,
              employeeDepartment:this.employeeDepartment,
              employeeMobile:this.employeeMobile,
              agentNumber:this.agentNumber,
              agentExten:newAgentExten,
              employeeSex:this.employeeSex,
              employeeArea:this.employeeArea,
              isAdmin:this.employeeManager,
              employeeAge:this.employeeAge,
              employeeBirthday:employeeBirthday,
              employeeEmail:this.employeeEmail,
              agentPassword:newAgentPassWord,
              employeeWx:this.employeeWx,
              hiddenPhone:this.hiddenPhone,
              pstnNumber:this.pstnNumber.toString(),
              supportVideo:this.supportVideo,
              aiAssistant:this.aiAssistant,
              supportChat:this.supportChat,
              id:this.id,
              journalType:journalType,
              menuId:menuId,
              viewAllCustomer:this.viewAllCustomer,
              employeeType:this.employeeType
            };
            if(this.agentId != '' && this.agentExten == '请选择分机号'){
              param.agentExten='';
              param.agentPassword='';
            }
            this.saveDisabled=true;
            this.$http.post(url,param) .then(function (res) {
              let result=res.data;
              that.saveDisabled=false;
              if(result.flag!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.$Modal.info({
                title:'提示',
                content:that.title+"成功"
              });
              that.$emit("closeAgentEditPop",true);
            })
          },
          checkPhoneNumber:function(event){
            let name=event.currentTarget.name;
            let value=event.currentTarget.value;
            let reg=/^[0-9]*$/;
            if(!reg.test(value)){
              this.$Modal.info({
                title:'提示',
                content:name+"只能输入数字"
              });
              return false;
            }
          },
          initSearch:function () {
            if(!this.id){
              return false;
            }
            let that=this;
            let param={
              id:this.id,
              journalType:"null",
              menuId:"null"
            };
            this.$http.post("employee/selectAllEmp.json",param) .then(function (res) {
              let result=res.data;
              if(result.flag!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }

              let list=result.obj.list.content[0];
              that.employeeCode=list.employeeCode;
              that.employeeName=list.employeeName;
              that.employeeRole=list.employeeRoleId;
              that.employeeDepartment=list.employeeDepartmentList.split(',');
              that.employeeMobile=list.employeeMobile;
              that.agentNumber=list.agentNumber;
              that.agentExten=list.agentExten;
              that.employeeSex=list.employeeSex;
              that.employeeArea=list.employeeArea;
              that.employeeManager=list.isAdmin;
              that.employeeAge=list.employeeAge;
              that.employeeBirthday=list.employeeBirthday;
              that.employeeEmail=list.employeeEmail;
              if(that.agentExten != '' && that.agentExten != null){
                that.extenPassword=list.agentPassword;
              }
              that.employeeWx=list.employeeWx;
              that.hiddenPhone=list.hiddenPhone;
              that.aiAssistant = list.aiAssistant+"";
              that.supportVideo = list.supportVideo+"";
              that.supportChat = list.supportChat+"";
              that.viewAllCustomer = list.viewAllCustomer+"";
              that.employeeType = list.employeeType+"";
              if(list.pstnNumber){
                that.pstnNumber=list.pstnNumber.split(",");
              }
              let count=0;
              let agentExten=that.companyId+list.agentNumber;
              for(let i=0;i<that.extenList.length;i++){
                let exten=that.extenList[i].agentExten;
                if(agentExten==exten){
                  count++;
                }
              }
              if(count==0){
                let param={
                  'agentExten':agentExten
                };
                that.extenList.unshift(param)
              }
            })
          }
        },
        watch:{
          showAgent:function () {
            this.title=this.showTitle;
            this.model=this.showAgent;
            this.id=this.agentId;
            this.saveDisabled=false;
            this.employeeRoleList=this.employeeList;
            this.employeeDepartmentList=this.departmentList;
            this.extenList=this.agentExtenList;
            this.disabled=true;
            this.employeeCode="";
            this.employeeName="";
            this.employeePassword="******";
            this.employeeRole="";
            this.employeeDepartment = [];
            this.employeeMobile="";
            this.agentNumber="";
            this.agentExten="";
            this.employeeSex="1";
            this.employeeArea="";
            this.employeeManager="0";
            this.employeeAge="";
            this.employeeBirthday="";
            this.employeeEmail="";
            this.extenPassword="";
            this.employeeWx="";
            this.hiddenPhone="0";
            this.editOrAdd=true;
            this.pstnNumber=[];
            this.aiAssistant="0";
            this.supportVideo = "0";
            this.supportChat = "0";
            this.viewAllCustomer = "0";
            this.employeeType = "0";
            if(this.showAgent){
              let agentInfo=JSON.parse(localStorage.getItem("agentInfo"));
              if(agentInfo.isAdmin=='1'){
                this.disabled=false;
              }
              this.getPstnNumber("0");
              this.initSearch();
              this.addOrEdit = true;
              if(!this.agentId){
                this.addOrEdit = false;
                this.employeePassword="";
                let letter=['a','b','c','d','e','f','g','h','i','j'];
                for(let i=0; i<4; i++){
                  let count=parseInt(Math.random()*10);
                  let letterSum=letter[count];
                  let result=letterSum+count;
                  if(this.extenPassword){
                    this.extenPassword=result+this.extenPassword;
                  }else {
                    this.extenPassword=result;
                  }
                }
                this.editOrAdd=false;
                this.disabled=false;
              }
            }
          }
        }
    }
</script>

<style scoped lang="less">
.insert_edit_input{
  .el-cascader{
    .el-input{
      .el-input__inner{
        border-radius: 0px !important;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/agentManage/AgentEditPop.vue